import React, { useState } from 'react';
import styles from './DeleteUserModal.module.scss';
import { Button, Icon, Modal, Text } from 'components';
import { useDevice } from 'hooks';
import { usersActions } from 'store/users/slice';
import { useDispatch } from 'store/utils';
import { UserStatus } from 'types';

type Props = {
  onClose(): void;
  userId: string;
  name: string;
};

export const DeleteUserModal = ({ onClose, userId, name }: Props) => {
  const { isTablet } = useDevice();
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const onDeleteUserHandler = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      await dispatch(usersActions.deleteUser(userId));
      onClose();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title="Delete user" onClose={onClose}>
      <div className={styles.content}>
        {isTablet && <Icon name="Tick" className={styles.icon} />}
        <Text type="body-big">Are you sure you want to delete this user?</Text>
        <Text type="body2" className={styles.info}>
          {name} will be deleted from the system
        </Text>
      </div>
      <div className={styles.buttonRow}>
        <Button isLink onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onDeleteUserHandler}>Delete</Button>
      </div>
    </Modal>
  );
};
